import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errText, LOGO_URL } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(errText(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-sm fade-up">
        <div className="text-center mb-12">
          <img src={LOGO_URL} alt="ARK Furniture" className="h-16 mx-auto mb-6" />
          <h1 className="font-display text-2xl tracking-tight">Revival Quote Builder</h1>
          <div className="w-12 h-[2px] bg-[#c19a6b] mx-auto mt-4" />
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-xs uppercase tracking-[0.15em]">Email</Label>
            <Input
              id="email"
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="h-12 rounded-sm"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="text-xs uppercase tracking-[0.15em]">Password</Label>
            <Input
              id="password"
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="h-12 rounded-sm"
            />
          </div>
          {error && (
            <p data-testid="login-error" className="text-sm text-red-600">{error}</p>
          )}
          <Button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-black hover:bg-black/85 text-white rounded-sm tracking-[0.15em] uppercase text-xs btn-lift"
          >
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
        <p className="text-center text-xs text-gray-400 mt-10 tracking-wide">Staff access only</p>
      </div>
    </div>
  );
}
